import { Hidden } from '@material-ui/core'
import React from 'react'

import DesktopMenu from './DesktopMenu'
import MobileMenu from './MobileMenu'
import MobileSidebarMenu from './MobileSidebarMenu'
import SidebarMenu from './SidebarMenu'

const AppBarMenu = ({ appBarHeight, sidebar, userType, userCategory }) =>
  sidebar ? (
    <>
      <MobileSidebarMenu
        appBarHeight={appBarHeight}
        userType={userType}
        userCategory={userCategory}
      />
      <Hidden smDown>
        <SidebarMenu
          userType={userType}
          userCategory={userCategory}
          side="left"
          style={{
            top: appBarHeight,
            left: 0,
            position: 'fixed',
          }}
        />
      </Hidden>
    </>
  ) : (
    <div css={{ display: 'flex' }}>
      <Hidden mdUp>
        <MobileMenu />
      </Hidden>
      <Hidden smDown>
        <DesktopMenu />
      </Hidden>
    </div>
  )

export default AppBarMenu
